// @flow
import React from 'react';
import striptags from 'striptags';

export type SearchSuggestion = {
  comfortLevel: string,
  icon: string,
  image: string,
  label: string,
  link?: string,
  productId: string,
  productType: string,
  season: string,
  subLabel1: string,
  subLabel2: string,
  type: string,
};

export type SearchSuggestionsProps = {
  autocompleteQuery: string,
  autocompleteResults: Array<SearchSuggestion>,
  clearGlobalSearch: () => void,
};

export type SearchSuggestionsBlockProps = {
  ...$Exact<SearchSuggestionsProps>,
  blockSuggestions: Array<SearchSuggestion>,
  isDesktop: boolean,
  onClick: (query: SearchQuery) => mixed,
};

export const SUGGESTION_TYPES = {
  ACTIVITY: 'activity',
  AREA: 'area',
  COUNTRY: 'country',
  RESORT: 'resort',
};

export const GlobalSearchSuggestionsList = (props: SearchSuggestionsBlockProps) => {
  const maxNumberOfSuggestions = props.isDesktop ? 5 : 3;
  const onPress = suggestion => {
    props.onClick(suggestion);
  };

  return (
    <ul className="list-none p-0 mb-6">
      {props.blockSuggestions
        .slice(0, maxNumberOfSuggestions)
        .map(({ label, type }) => ({ label: striptags(label), type }))
        .map((suggestion, index) => {
          const { label, type } = suggestion;
          return (
            <li key={label} className="mb-3" data-testid={`${type}-link`}>
              <span
                role="button"
                tabIndex={index}
                className="leading-tight font-bold text-xl lg:text-2xl text-gray cursor-pointer"
                onClick={() => onPress(suggestion)}
                onKeyUp={event => {
                  /* Space & Enter */
                  if (event.keyCode === 32 || event.keyCode === 13) {
                    onPress(suggestion);
                  }
                }}
              >
                {label}
              </span>
            </li>
          );
        })}
    </ul>
  );
};
